<template>
  <div class="hello">
    <p>Click the button below, navigate to Dropbox folder "WNE - team/WNE 2020/test_photos", and select all photos with ctrl+a or cmd+a</p>
    <input type="file" multiple="true" @change="processChosenFiles($event)">

    <div v-if="fileObjects.length > 0">
      <p>Press a number between 2 and 5 to score a photo</p>
      <p>Or press b to go back to the previous photo to re-score it</p>
      <h3>Image {{ currentFileIndex + 1}} of {{ fileObjects.length }}</h3>
      
      <img id="img" :src="currentImageData">
      <h3>Title: {{ fileObjects[currentFileIndex].name }}</h3>

      <hr>
      <h3>scores</h3>
      <p v-for="(score, title) in scores" :key="title">
        {{ title }}: <strong>{{ score }}</strong>
      </p>
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data: function() {
    return {
      fileObjects: {},
      currentFileIndex: 0,
      currentImageData: '',
      scores: {},
      acceptingKeyPresses: false
    }
  },
  mounted() {
    window.addEventListener('keypress', e => {
      if (this.acceptingKeyPresses) {
        const char = String.fromCharCode(e.keyCode);
        console.log(`user pressed key: ${char}`)
        const number = parseInt(char);
        if (!isNaN(number)) {
          console.log(`user pressed number key: ${char}`);
          if (number >= 2 && number <= 5) {
            console.log(`user pressed number key in range (2-5): ${char}`);
            const filename = this.fileObjects[this.currentFileIndex].name;
            console.log(`saving score for ${filename}: ${number}`);
            if (filename in this.scores) {
              console.log('this file already exists, overwriting score');
            }
            this.scores[filename] = number;
            this.$forceUpdate();
            console.log('scores updated')
            this.goToNextImage();
          }
        } else {
          if (char === 'b') {
            this.goToPreviousImage();
          }
        }

      }
    });
  },
  methods: {
    processChosenFiles(event) {
      const files = event.target.files;
      console.log(files);
      this.fileObjects = files;

      this.currentFileIndex = 0;
      this.readFile();
      
      this.acceptingKeyPresses = true;
   },

   goToNextImage() {
     if ((this.currentFileIndex + 1) > (this.fileObjects.length - 1)) {
        alert('No more photos to score');
        return;
      }
      this.currentFileIndex += 1;
      this.readFile();
   },

   goToPreviousImage() {
      if (this.currentFileIndex > 0) {
        this.currentFileIndex -= 1;
        this.readFile();
      }
   },

   readFile() {
     const file = this.fileObjects[this.currentFileIndex];
     const reader = new FileReader();
      reader.addEventListener('load', () => {
        // convert image file to base64 string
        this.currentImageData = reader.result;
      }, false);
      reader.readAsDataURL(file);
   },
  }
}
</script>

<style scoped>
input {
  margin: 10px;
  padding-left: 70px;
}
img#img {
  width: 100%;
  max-width: 1500px;
}
</style>
